import QTabs from './src/tabs';


export default QTabs;
